export const flooriVariables = {
    priceTag: {
        bgColor: '#00000066',
        color: '#ffffff',
    },
} as const;
